import { h, Component } from 'preact';

import { SadlibAd } from '../sadlib-ad';
import { TaboolaJs } from '../taboola-js';

/** Creates autoplay insertion
 */
export class Autoplay extends Component {

	shouldComponentUpdate = () => false;

	render({ autoplay, taboola, id }) {
		// Taboola 1x1
		if (taboola) return <TaboolaJs {...taboola} qeId="sc-home-taboolaautoplay" />;

		// Synacor Autoplay
		// First check if should display
		if (
			(window.SynDetectPii && window.SynDetectPii.hasPii && window.SynDetectPii.hasPii()) ||
			(window.Sadlib_Config && window.Sadlib_Config.babu)
		) return;

		// Use direct injection if src available
		if (autoplay.clientParams) {
			let size = autoplay.regularSize;
			return (
				<div>
					<script src={`${autoplay.baseUrl}?${size}&${autoplay.clientParams}`} async />
				</div>);
		}

		// Use sadlib based autoplay
		return <SadlibAd id={id} type="desktopAutoplay" label="Autoplay" />;
	}
}
